module.exports = __webpack_public_path__ + "img/08-W.4a091a53.svg";